/* Camp Right — new PDP behaviour.
   Gallery swipe/dots/thumbnail sync, variant selection, quantity, add-ons and
   the mobile sticky bar. Written to survive theme-editor section re-renders. */
(function () {
  'use strict';

  /* ---------------- gallery ---------------- */

  function setCurrent(nodes, idx) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
    }
  }

  function syncGallery(root, idx) {
    setCurrent(root.querySelectorAll('[data-crn-thumb]'), idx);
    setCurrent(root.querySelectorAll('[data-crn-dot]'), idx);
  }

  function indexFromScroll(track) {
    var w = track.clientWidth;
    if (!w) return 0;
    var last = track.children.length - 1;
    return Math.max(0, Math.min(last, Math.round(track.scrollLeft / w)));
  }

  function watchTrack(root, track) {
    if (track.dataset.crnWatch) return;
    track.dataset.crnWatch = '1';
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncGallery(root, indexFromScroll(track));
      }, 80);
    }, { passive: true });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var hit = e.target.closest('[data-crn-thumb],[data-crn-dot]');
    if (!hit) return;
    var root = hit.closest('[data-crn-hero]');
    if (!root) return;
    var track = root.querySelector('[data-crn-track]');
    if (!track) return;
    var group = hit.hasAttribute('data-crn-dot')
      ? root.querySelectorAll('[data-crn-dot]')
      : root.querySelectorAll('[data-crn-thumb]');
    var idx = Array.prototype.indexOf.call(group, hit);
    if (idx < 0) return;
    goToSlide(root, track, idx);
  });

  /* Assigning scrollLeft rather than calling scrollTo({behavior:'smooth'}):
     with scroll-snap-type mandatory + scroll-snap-stop always, Chrome silently
     drops the programmatic smooth scroll and the track never moves. The
     animation comes from `scroll-behavior: smooth` in the CSS instead. */
  function goToSlide(root, track, idx) {
    track.scrollLeft = idx * track.clientWidth;
    syncGallery(root, idx);
  }

  /* ---------------- thumbnail rail scroll arrows ----------------
     The reference site renders these inside a <scroll-shadow> custom element's
     shadow DOM: a 41px white bar pinned to the top and bottom edge of the rail
     with a 24×24 chevron, each shown only when there is more to scroll that
     way. Rebuilt here as real buttons so they also work as controls. */

  function chevron(dir) {
    var d = dir === 'up' ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6';
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function setupRail(root) {
    var rail = root.querySelector('.crn-gal__thumbs');
    if (!rail || rail.dataset.crnRail) return;
    rail.dataset.crnRail = '1';

    /* wrap the rail so the arrows can sit over it without scrolling away */
    var wrap = document.createElement('div');
    wrap.className = 'crn-rail';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);

    function make(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'crn-rail__btn crn-rail__btn--' + dir;
      b.setAttribute('aria-label', dir === 'up' ? 'Scroll thumbnails up' : 'Scroll thumbnails down');
      b.innerHTML = chevron(dir);
      wrap.appendChild(b);
      return b;
    }
    var up = make('up');
    var down = make('down');

    function step() {
      var t = rail.querySelector('.crn-thumb');
      var gap = parseFloat(getComputedStyle(rail).rowGap) || 16;
      return (t ? t.offsetHeight : 96) + gap;
    }

    function refresh() {
      var canUp = rail.scrollTop > 2;
      var canDown = rail.scrollTop + rail.clientHeight < rail.scrollHeight - 2;
      up.classList.toggle('is-shown', canUp);
      down.classList.toggle('is-shown', canDown);
    }

    /* The rail's `scroll` event does not fire in Chrome here, even though
       scrollTop changes and sticks — so refresh() is called explicitly after
       every interaction rather than being driven by the scroll event alone. */
    up.addEventListener('click', function () { rail.scrollTop -= step(); refresh(); });
    down.addEventListener('click', function () { rail.scrollTop += step(); refresh(); });
    rail.addEventListener('scroll', refresh, { passive: true });
    rail.addEventListener('wheel', function () { setTimeout(refresh, 60); }, { passive: true });
    rail.addEventListener('touchmove', function () { setTimeout(refresh, 60); }, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  }

  /* ---------------- image zoom ----------------
     Matches the reference site's control: a 40x40 translucent circle 16px in
     from the top-right of the main image, holding a 16px expand icon. Theirs
     opens the media in a modal; this opens a full-screen lightbox showing the
     slide that is currently in view. */

  var EXPAND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'aria-hidden="true" focusable="false"><path stroke-linecap="round" stroke-linejoin="round" ' +
    'd="M3 3V9M3 3H9M3 3L9 9M21 21V15M21 21H15M21 21L15 15"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'aria-hidden="true" focusable="false"><path stroke-linecap="round" stroke-linejoin="round" ' +
    'd="M6 6l12 12M18 6L6 18"/></svg>';

  var box;

  function lightbox() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'crn-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<img alt=""><button type="button" class="crn-lightbox__close" ' +
      'aria-label="Close">' + CLOSE + '</button>';
    document.body.appendChild(box);

    function close() {
      box.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    box.addEventListener('click', function (e) {
      /* backdrop or the close button, but not the image itself */
      if (e.target === box || e.target.closest('.crn-lightbox__close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });
    return box;
  }

  function openZoom(root) {
    var track = root.querySelector('[data-crn-track]');
    var idx = track ? indexFromScroll(track) : 0;
    var img = root.querySelectorAll('.crn-gal__slide img')[idx];
    if (!img) return;
    var b = lightbox();
    /* srcset gives the browser the widest candidate for a full-screen view */
    var full = b.querySelector('img');
    full.src = img.currentSrc || img.src;
    full.alt = img.alt || '';
    b.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function setupZoom(root) {
    var main = root.querySelector('.crn-gal__main');
    if (!main || main.dataset.crnZoom) return;
    main.dataset.crnZoom = '1';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'crn-zoom';
    b.setAttribute('aria-label', 'Zoom product image');
    b.innerHTML = EXPAND;
    b.addEventListener('click', function () { openZoom(root); });
    main.appendChild(b);
  }

  /* ---------------- buy box ---------------- */

  function initBuyBox(root) {
    if (root.dataset.crnInit) return;
    root.dataset.crnInit = '1';

    var sectionEl = root.closest('[id^="shopify-section-"]');
    var sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    var strings = (window.crnStrings && sectionId && window.crnStrings[sectionId]) || {};
    var btnLabel = strings.buttonLabel || 'Add to cart';

    var variants = [];
    var dataEl = root.querySelector('[data-crn-variants]');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; } }

    var track = root.querySelector('[data-crn-track]');
    if (track) watchTrack(root, track);
    setupRail(root);
    setupZoom(root);

    var form = root.querySelector('#crn-product-form');
    var idInput = root.querySelector('[data-crn-variant-id]');
    var qtyInput = root.querySelector('[data-crn-qty]');
    var atc = root.querySelector('[data-crn-atc]');
    var atcText = root.querySelector('[data-crn-atc-text]');
    var now = root.querySelector('[data-crn-now]');
    var was = root.querySelector('[data-crn-was]');
    var save = root.querySelector('[data-crn-save]');
    var stickyNow = root.querySelector('[data-crn-sticky-now]');
    var groups = root.querySelectorAll('[data-crn-option-index]');

    /* quantity */
    if (qtyInput) {
      var dec = root.querySelector('[data-crn-dec]');
      var inc = root.querySelector('[data-crn-inc]');
      if (dec) dec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      if (inc) inc.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10);
        qtyInput.value = (isNaN(v) || v < 1) ? 1 : v;
      });
    }

    /* variants */
    function selectedOptions() {
      var opts = [];
      groups.forEach(function (g) {
        var on = g.querySelector('.crn-opt__btn[aria-pressed="true"]');
        opts.push(on ? on.dataset.crnOptionValue : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function valueAvailable(gi, value, opts) {
      var test = opts.slice();
      test[gi] = value;
      return variants.some(function (v) {
        return v.available && v.options.length === test.length &&
          v.options.every(function (o, i) { return o === test[i]; });
      });
    }

    function updateAvailability() {
      var current = selectedOptions();
      groups.forEach(function (g, gi) {
        g.querySelectorAll('.crn-opt__btn').forEach(function (btn) {
          if (valueAvailable(gi, btn.dataset.crnOptionValue, current)) {
            btn.removeAttribute('aria-disabled');
          } else {
            btn.setAttribute('aria-disabled', 'true');
          }
        });
      });
    }

    function update() {
      if (!groups.length) return;
      var v = findVariant(selectedOptions());
      if (v) {
        if (idInput) idInput.value = v.id;
        if (now) now.textContent = v.price_money;
        if (stickyNow) stickyNow.textContent = v.price_money;
        if (v.compare > v.price) {
          if (was) was.textContent = v.compare_money;
          if (save) save.textContent = 'Save ' + Math.round((v.compare - v.price) / v.compare * 100) + '%';
        } else {
          /* Previously these were only ever written, never cleared, so moving
             from a discounted variant to a full-price one left the old
             strikethrough and SAVE pill on screen next to the new price. */
          if (was) was.textContent = '';
          if (save) save.textContent = '';
        }

        /* Shop Pay instalments banner. Shopify's <shopify-payment-terms>
           re-renders itself when its variant-id attribute changes. Without
           this it stays pinned to whichever variant was selected when the page
           loaded, so switching bundle showed the wrong variant's terms - and
           because the first variant is under the eligibility threshold it fell
           back to the generic "for orders over" copy rather than the real
           instalment figure. The figures themselves are always Shopify's, not
           ours; we only tell it which variant is selected. */
        var terms = root.querySelector('shopify-payment-terms');
        if (terms) terms.setAttribute('variant-id', v.id);

        /* Sticky bar's strikethrough had no updater, so it kept the first
           variant's compare-at price beside the newly selected variant's
           price - a wrong number on screen, not just a stale style. */
        var stickyWas = root.querySelector('.crn-sticky__was');
        if (stickyWas) stickyWas.textContent = (v.compare > v.price) ? v.compare_money : '';
        if (v.available) {
          atc.disabled = false;
          atcText.textContent = btnLabel + ' · ' + v.price_money;
        } else {
          atc.disabled = true;
          atcText.textContent = 'Sold out';
        }
      } else {
        atc.disabled = true;
        atcText.textContent = 'Unavailable';
      }
      updateAvailability();
    }

    groups.forEach(function (g) {
      g.querySelectorAll('.crn-opt__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          g.querySelectorAll('.crn-opt__btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });

    /* add to cart — posts the main variant plus any ticked add-ons */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        var addons = [];
        root.querySelectorAll('[data-crn-addon]').forEach(function (cb) {
          if (cb.checked && cb.value) addons.push({ id: Number(cb.value), quantity: 1 });
        });

        e.preventDefault();
        var prev = atcText.textContent;
        atc.disabled = true;
        atcText.textContent = 'Adding…';

        var items = [{
          id: Number(idInput.value),
          quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1
        }].concat(addons);

        fetch((strings.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw res;
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              document.dispatchEvent(new CustomEvent('crn:added'));
              window.location.href = strings.cartUrl || '/cart';
            } else {
              window.location.href = strings.cartUrl || '/cart';
            }
          })
          .catch(function (err) {
            atc.disabled = false;
            atcText.textContent = prev;
            alert(err && err.description ? err.description : 'Could not add to cart.');
          });
      });
    }

    var stickyBtn = root.querySelector('[data-crn-sticky-btn]');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    update();
  }

  /* ---------------- accordions (tabs / FAQ) ---------------- */

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var head = e.target.closest('[data-crn-acc-head]');
    if (!head) return;
    var item = head.closest('[data-crn-acc-item]');
    var group = head.closest('[data-crn-acc]');
    if (!item || !group) return;
    var isOpen = item.classList.contains('is-open');
    if (group.hasAttribute('data-crn-acc-single')) {
      group.querySelectorAll('[data-crn-acc-item]').forEach(function (x) {
        x.classList.remove('is-open');
        var h = x.querySelector('[data-crn-acc-head]');
        if (h) h.setAttribute('aria-expanded', 'false');
      });
    }
    if (!isOpen) {
      item.classList.add('is-open');
      head.setAttribute('aria-expanded', 'true');
    } else if (!group.hasAttribute('data-crn-acc-single')) {
      item.classList.remove('is-open');
      head.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------------- boot ---------------- */

  function boot() {
    document.querySelectorAll('[data-crn-hero]').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
